module.exports = __webpack_public_path__ + "img/VIP.d66a7e42.png";